// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/component/compact_block/v1/compact_block.proto (package penumbra.core.component.compact_block.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { CommitmentSource, Nullifier } from "../../sct/v1/sct_pb.js";
import { MerkleRoot, StateCommitment } from "../../../../crypto/tct/v1/tct_pb.js";
import { FmdParameters, NotePayload } from "../../shielded_pool/v1/shielded_pool_pb.js";
import { BatchSwapOutputData, SwapPayload } from "../../dex/v1/dex_pb.js";
import { GasPrices } from "../../fee/v1/fee_pb.js";

/**
 * Contains the minimum data needed to update client state.
 *
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlock
 */
export const CompactBlock = proto3.makeMessageType(
  "penumbra.core.component.compact_block.v1.CompactBlock",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "state_payloads", kind: "message", T: StatePayload, repeated: true },
    { no: 3, name: "nullifiers", kind: "message", T: Nullifier, repeated: true },
    { no: 4, name: "block_root", kind: "message", T: MerkleRoot },
    { no: 5, name: "epoch_root", kind: "message", T: MerkleRoot },
    { no: 6, name: "proposal_started", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "fmd_parameters", kind: "message", T: FmdParameters },
    { no: 8, name: "swap_outputs", kind: "message", T: BatchSwapOutputData, repeated: true },
    { no: 9, name: "app_parameters_updated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "gas_prices", kind: "message", T: GasPrices },
    { no: 100, name: "alt_gas_prices", kind: "message", T: GasPrices, repeated: true },
    { no: 11, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * An encrypted payload, corresponding to a single commitment in the state commitment tree.
 *
 * @generated from message penumbra.core.component.compact_block.v1.StatePayload
 */
export const StatePayload = proto3.makeMessageType(
  "penumbra.core.component.compact_block.v1.StatePayload",
  () => [
    { no: 1, name: "source", kind: "message", T: CommitmentSource },
    { no: 2, name: "rolled_up", kind: "message", T: StatePayload_RolledUp, oneof: "state_payload" },
    { no: 3, name: "note", kind: "message", T: StatePayload_Note, oneof: "state_payload" },
    { no: 4, name: "swap", kind: "message", T: StatePayload_Swap, oneof: "state_payload" },
  ],
);

/**
 * @generated from message penumbra.core.component.compact_block.v1.StatePayload.RolledUp
 */
export const StatePayload_RolledUp = proto3.makeMessageType(
  "penumbra.core.component.compact_block.v1.StatePayload.RolledUp",
  () => [
    { no: 1, name: "commitment", kind: "message", T: StateCommitment },
  ],
  {localName: "StatePayload_RolledUp"},
);

/**
 * @generated from message penumbra.core.component.compact_block.v1.StatePayload.Note
 */
export const StatePayload_Note = proto3.makeMessageType(
  "penumbra.core.component.compact_block.v1.StatePayload.Note",
  () => [
    { no: 2, name: "note", kind: "message", T: NotePayload },
  ],
  {localName: "StatePayload_Note"},
);

/**
 * @generated from message penumbra.core.component.compact_block.v1.StatePayload.Swap
 */
export const StatePayload_Swap = proto3.makeMessageType(
  "penumbra.core.component.compact_block.v1.StatePayload.Swap",
  () => [
    { no: 2, name: "swap", kind: "message", T: SwapPayload },
  ],
  {localName: "StatePayload_Swap"},
);

/**
 * Requests a range of compact block data.
 *
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlockRangeRequest
 */
export const CompactBlockRangeRequest = proto3.makeMessageType(
  "penumbra.core.component.compact_block.v1.CompactBlockRangeRequest",
  () => [
    { no: 2, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "end_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "keep_alive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlockRangeResponse
 */
export const CompactBlockRangeResponse = proto3.makeMessageType(
  "penumbra.core.component.compact_block.v1.CompactBlockRangeResponse",
  () => [
    { no: 1, name: "compact_block", kind: "message", T: CompactBlock },
  ],
);

/**
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlockRequest
 */
export const CompactBlockRequest = proto3.makeMessageType(
  "penumbra.core.component.compact_block.v1.CompactBlockRequest",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlockResponse
 */
export const CompactBlockResponse = proto3.makeMessageType(
  "penumbra.core.component.compact_block.v1.CompactBlockResponse",
  () => [
    { no: 1, name: "compact_block", kind: "message", T: CompactBlock },
  ],
);

